exports.__esModule = true;
exports.default = require('./lib/reduxMiddleware').default;
